export const LIGHT_GREEN = "#81C14B";
export const GREEN = "#2E933C";
export const DARK_GREEN = "#297045";

export const GREEN_BLUE = "#204E4A";
export const GREEN_YELLOW = "#EAE7B1";

export const RED = "lightsalmon";